var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBingSvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-bing-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 10.4648V15.8761",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5317 3.25C13.5517 3.25 8.70922 8.0925 8.70922 14.0725V17.485C8.70922 18.59 8.25422 20.2475 7.68547 21.19L5.62172 24.635C4.35422 26.7637 5.23172 29.1362 7.57172 29.9162C15.3392 32.5 23.7404 32.5 31.5079 29.9162C33.7017 29.185 34.6442 26.6175 33.4579 24.635L31.3942 21.19C30.8254 20.2475 30.3704 18.5737 30.3704 17.485V14.0725C30.3542 8.125 25.4792 3.25 19.5317 3.25Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.9103 30.582C24.9103 33.5558 22.4728 35.9933 19.4991 35.9933C18.0203 35.9933 16.6553 35.3758 15.6804 34.4008C14.7054 33.4258 14.0879 32.0608 14.0879 30.582",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 27.5,
    cy: 32.5,
    r: 4,
    fill: "#FF7C05",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBingSvgrepoCom1);
export default __webpack_public_path__ + "static/media/notification-bing-svgrepo-com 1.a9cb5d8b4f61bcab372893c09979fa10.svg";
export { ForwardRef as ReactComponent };